<aside class="sidebar-main">
        <div class="sidebar-header d-flex justify-content-between">
                <a class="logo-box" (click)="redirect()">
                        <img src="../../../../assets/img/cereus-logo.svg" alt="Cereus" class="cereus-logo"
                                *ngIf="!showCehreusLogo">
                        <img src="../../../../assets/img/cehreus-logo.svg" style="height: 39px !important;" alt="Cereus"
                                class="cereus-logo" *ngIf="showCehreusLogo">
                        <img src="../../../../assets/img/cereus-logo-icon.svg" alt="Cereus" class="cereus-icon">
                </a>
                <div class="toggle-icon hidden-mobile-nav" id="sidebarToggle" (click)="addBodyClass()">
                        <span class='icon-nav-arrow custom-icons toggle-arrow'>
                                <span class='path1'></span>
                                <span class='path2'></span>
                        </span>
                </div>
                <div class="visible-mobile-nav" (click)="addBodyClassMobile()">
                        <span></span>
                        <span></span>
                        <span></span>
                </div>
        </div>
        <div class="sidebar-content">
                <div class="accordion sidebar-nav" id="accordionExample">
                        <div class="accordion-item" *ngFor="let sec of sectionsList; let i = index">
                                <!-- Section Header -->
                                <h2 class="accordion-header" [id]="'heading-' + i">
                                        <button class="accordion-button sidebar-link collapsed" type="button"
                                                data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse-' + i"
                                                aria-expanded="false" [attr.aria-controls]="'collapse-' + i">

                                                <span class="sidebar-text">{{ sec.sectionName }}</span>
                                        </button>
                                </h2>
                                <!-- Collapsible Sub-navigation -->
                                <div [id]="'collapse-' + i" class="accordion-collapse collapse"
                                        [attr.aria-labelledby]="'heading-' + i" data-bs-parent="#accordionExample">

                                        <div class="accordion-body">
                                                <ul class="sub-nav">
                                                        <li *ngFor="let module of sectionModule">

                                                                <a class="k-link" routerLinkActive="active-link"
                                                                        *ngIf="module.sectionName === sec.sectionName"
                                                                        [routerLink]="module.navigationRoute"
                                                                        (click)="setTitle(module.moduleName)">

                                                                        {{ module.moduleName }}
                                                                </a>

                                                        </li>
                                                </ul>
                                        </div>
                                </div>
                        </div>

                        <!-- MVP First Version Menu -->
                        <div class="accordion-item" *ngFor="let module of mvpModuleList">
                                <h2 class="accordion-header" id="flush-headingOne" >
                                        <span [routerLink]="module.navigationRoute" routerLinkActive="active-link"
                                                [routerLinkActiveOptions]="{exact: true}"
                                                class="accordion-button sidebar-link statick-link"
                                                (click)="setTitle('{{module.moduleName}}', true)">
                                                <span class="sidebar-text">{{module.moduleName}}</span>
                                        </span>
                                </h2>
                        </div>
                </div>
        </div>
        <div class="version-text">
                <p>{{versionText}}--{{siteEnvironment}}</p>
                <p class="copyright-msg text-center">Copyright © Cereus Software {{currentYear}} All Rights Reserved.
                </p>
        </div>
</aside>

<!-- Overlay Responsive -->
<div class="responsive-overlay" (click)="addBodyClass()"></div>